"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["[name=num_trucks][_ngcontent-%COMP%]{width:154px}.app-content[_ngcontent-%COMP%]{overflow:hidden;display:flex;flex-direction:column}.customer-name[_ngcontent-%COMP%], .name[_ngcontent-%COMP%]{width:40%}"];
exports.styles = styles;
